import f from 'odata-filter-builder';
import { transformODataResponse } from 'utilities/query';
import templateUrl from './map-ingredients.html';

export default {
  templateUrl,
  bindings: {
    flex: '@',
    layout: '@',
    query: '<',
    queryMapped: '<'
  },
  controller: class MapIngredientsComponent {
    constructor($mdDialog, $scope, IngredientService, LoadingService, ToastService) {
      'ngInject';

      Object.assign(this, {
        $mdDialog,
        $scope,
        IngredientService,
        LoadingService,
        ToastService
      });
    }

    $onInit() {
      this.columns = [{
        FieldName: 'UserIngredientName',
        DisplayName: 'User Ingredient Name'
      }];

      this.selectedUserIngredients = [];
      this.selectedMappedIngredients = [];
      this.mappedUserIngredients = [];
    }

    refreshUserIngredients() {
      this.selectedUserIngredients = [];
      this.selectedMappedIngredients = [];

      let filter = f().ne('SystemIngredientId', this.selectedSystemIngredient.SystemIngredientId);
      if (this.userIngredientSearchText) {
        filter = filter.and(x => x.contains('UserIngredientName', this.userIngredientSearchText));
      }

      this.promise = this.IngredientService.searchUserIngredients({
        ...this.query,
        filter: filter.toString()
      });

      return this.promise.then((r) => {
        this.userIngredients = transformODataResponse(r);
      }).catch(error => this.ToastService.showError(error));
    }

    refreshMappedUserIngredients() {
      let filter = f().eq('SystemIngredientId', this.selectedSystemIngredient.SystemIngredientId);
      if (this.mappedUserIngredientSearchText) {
        filter = filter.and(x => x.contains('UserIngredientName', this.mappedUserIngredientSearchText));
      }

      this.promiseMapped = this.IngredientService.searchUserIngredients({
        ...this.queryMapped,
        filter: filter.toString()
      });

      return this.promiseMapped.then((r) => {
        this.mappedUserIngredients = transformODataResponse(r);
      }).catch(error => this.ToastService.showError(error));
    }

    selectedSystemIngredientChanged({ selectedIngredient }) {
      this.selectedSystemIngredient = selectedIngredient;

      if (selectedIngredient) {
        const promises = [
          this.refreshUserIngredients(),
          this.refreshMappedUserIngredients()
        ];

        Promise.all(promises);
      } else {
        this.userIngredients = [];
        this.mappedUserIngredients = [];
        this.userIngredientSearchText = null;
        this.mappedUserIngredientSearchText = null;
      }
    }

    addMapping(selectedSystemIngredient, selectedUserIngredients) {
      this.LoadingService.start();
      const userIngredientIds = selectedUserIngredients.map(u => u.UserIngredientId);

      this.IngredientService
        .addSystemIngredientMapping(selectedSystemIngredient.SystemIngredientId, userIngredientIds)
        .then(() => {
          this.selectedUserIngredients = [];

          const promises = [
            this.refreshUserIngredients(),
            this.refreshMappedUserIngredients()
          ];

          Promise.all(promises).then(() => this.ToastService.showSuccess('User ingredients mapped successfully!'));
        })
        .catch(error => this.ToastService.showError(error))
        .finally(() => this.LoadingService.stop());
    }

    removeMapping(selectedSystemIngredient, selectedUserIngredients) {
      this.LoadingService.start();
      const userIngredientIds = selectedUserIngredients.map(u => u.UserIngredientId);

      this.IngredientService
        .removeSystemIngredientMapping(selectedSystemIngredient.SystemIngredientId, userIngredientIds)
        .then(() => {
          this.selectedMappedIngredients = [];

          const promises = [
            this.refreshUserIngredients(),
            this.refreshMappedUserIngredients()
          ];

          Promise.all(promises).then(() => this.ToastService.showSuccess('User ingredients unmapped successfully!'));
        })
        .catch(error => this.ToastService.showError(error))
        .finally(() => this.LoadingService.stop());
    }

    onIngredientSearchTextChanged({ searchText }) {
      this.selectedUserIngredients = [];
      this.userIngredientSearchText = searchText;
      this.refreshUserIngredients();
    }

    onQueryChanged({ query }) {
      this.selectedUserIngredients = [];
      this.query = query;
      this.refreshUserIngredients();
    }

    onMappedIngredientSearchTextChanged({ searchText }) {
      this.selectedMappedIngredients = [];
      this.mappedUserIngredientSearchText = searchText;
      this.refreshMappedUserIngredients();
    }

    onMappedQueryChanged({ query }) {
      this.selectedMappedIngredients = [];
      this.queryMapped = query;
      this.refreshMappedUserIngredients();
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/map-ingredients/map-ingredients.component.js